import * as React from 'react'

import { TQSubmittedOrderVariables, useQSubmittedOrder } from '~graphql/generated/clientGraphql'
import { getOrderFromUrl } from '~logic/helpers/getOrderFromUrl'

type TOptions = {
  orderId: ReturnType<typeof getOrderFromUrl>['orderId']
}

/**
 * Loads the order info that is required for the submitted order tracking screen.
 */
export const useLoadSubmittedOrder = ({ orderId }: TOptions) => {
  const variables = React.useMemo<TQSubmittedOrderVariables | undefined>(() => {
    return orderId ? { orderId } : undefined
  }, [orderId])

  const { data, loading, error } = useQSubmittedOrder({
    variables,
    skip: !variables,
  })

  if (loading) {
    return { order: null, loading }
  }

  if (!data || error) {
    return { order: null, loading, error }
  }

  return { order: data.order, loading }
}
